import React from "react";

const CardActionsRight = ({ children }) => {
    return <div className="ActionsBar-right">{children}</div>;
};
export default CardActionsRight;
